module.exports = __webpack_public_path__ + "img/content4-5.d6d0e861.webp";